import React from 'react';
// import { Link } from 'react-router-dom';

const homeStyle = {
	textAlign: "center"
}

const Home = () => {
	
	return (
		<div style={homeStyle}>
			<h1>Home page</h1>
			<h2>Try searching for videos and watching them!</h2>
		</div>
	);

}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js